import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import {
  collection,
  getDocs,
  Timestamp,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import { MemberContext } from "../Contexts/MemberContext";
import MarkdownPreview from "./common/MarkdownPreview";

import "./CommonIntroduction.scss";

const VideoProduction = () => {
  const { currentUserInfo } = useContext(MemberContext);
  const isAdmin = currentUserInfo?.administrator === true;

  const componentName = "videoproduction";
  const slide = "動画の作成と発信（youtubeを活用)";
  const navigate = useNavigate();

  const [targetDataList, setTargetDataList] = useState([]);

  /* =====================
     Firestore 取得
  ===================== */
  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, componentName), orderBy("order", "asc"));
      const snap = await getDocs(q);

      const list = snap.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          eventdate:
            data.eventdate instanceof Timestamp
              ? data.eventdate.toDate().toLocaleString()
              : data.eventdate,
        };
      });

      const truncateText = (text, length = 40) => {
        if (!text) return "";
        return text.length > length ? text.slice(0, length) + "…" : text;
      };

      setTargetDataList(list);
    };

    fetchData();
  }, []);

  return (
    <div className="commonintroduction-container">
      <div className="commonintroduction-content">
        <div className="commonintroduction-title">
          <div className="commonintroduction-titletext">{slide}</div>

          {/* 追加 */}
          {isAdmin && (
            <div
              className="commonintroduction-post"
              onClick={() =>
                navigate("/firestoreservice", {
                  state: {
                    posttitle: "動画",
                    databasename: componentName,
                    targetitems: [
                      "order",
                      "eventday",
                      "title",
                      "content",
                      "youtubeUrl",
                    ],
                  },
                })
              }
            >
              <span className="commonintroduction-post-text">追 加</span>
            </div>
          )}
        </div>

        <div className="commonintroduction-box-wrap">
          {targetDataList.map((item) => (
            <div className="commonintroduction-box" key={item.id}>
              <div className="commonintroduction-box-title">
                <span className="commonintroduction-box-title-text">
                  {item.title}
                </span>

                {/* 編集 */}
                {isAdmin && (
                  <button
                    className="commonintroduction-box-edit-button"
                    onClick={() =>
                      navigate(`/firestoreservice/${item.id}/edit`, {
                        state: {
                          posttitle: "動画",
                          databasename: componentName,
                          targetitems: [
                            "order",
                            "eventday",
                            "title",
                            "content",
                            "youtubeUrl",
                          ],
                          targetData: item,
                        },
                      })
                    }
                  >
                    ︙
                  </button>
                )}
              </div>

              <div className="commonintroduction-box-youtube">
                <ReactPlayer
                  url={item.youtubeUrl}
                  width="100%"
                  height="100%"
                  controls
                />
              </div>

              {/* ★ マークダウンプレビュー表示 */}
              <div
                className="commonintroduction-box-content"
                onClick={() => navigate(`/post/videoproduction/${item.id}`)}
                style={{ cursor: "pointer" }}
              >
                <MarkdownPreview content={item.content} maxLength={40} />
                <div style={{ fontSize: "0.8rem", color: "#aaa" }}>
                  続きを読む...
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoProduction;
